import fs from 'node:fs'
import path from 'node:path'
import os from 'node:os'
import { transformContent, getGsdMunchHome, getPkgRoot } from './assets.js'

/**
 * Target directory for Claude Code agent files.
 * Agent filenames preserve gsd-* naming (gsd-executor.md, gsd-planner.md, etc.)
 * as these are internal implementation names referenced by workflows.
 */
export const AGENTS_DIR = path.join(os.homedir(), '.claude', 'agents')

/**
 * Reads all .md agent files from the package agents/ directory,
 * applies transformContent to each (updating paths and /gsd: -> /gm: namespace),
 * and writes them to ~/.claude/agents/.
 *
 * IMPORTANT: Agent filenames are preserved as gsd-*.md — the /gm: namespace
 * change applies only to user-facing command stubs. Agent names are internal
 * identifiers referenced by workflows when spawning subagents.
 *
 * Creates the target directory if it doesn't exist.
 * Safe to re-run — overwrites existing agent files (idempotent by design).
 *
 * @param gsdMunchHome Deployed assets home directory (defaults to ~/.claude/gsd-munch)
 */
export async function registerAgents(gsdMunchHome = getGsdMunchHome()): Promise<void> {
  const agentSrcDir = path.join(getPkgRoot(), 'agents')

  if (!fs.existsSync(agentSrcDir)) {
    return
  }

  fs.mkdirSync(AGENTS_DIR, { recursive: true })

  for (const file of fs.readdirSync(agentSrcDir)) {
    if (!file.endsWith('.md')) continue
    const content = fs.readFileSync(path.join(agentSrcDir, file), 'utf-8')
    const adapted = transformContent(content, gsdMunchHome)
    // Agent filenames stay as gsd-*.md — no name transformation
    fs.writeFileSync(path.join(AGENTS_DIR, file), adapted, 'utf-8')
  }
}
